<template>
  <div class="dir-list">
    <div
      :class="[wordNoDir ? 'nwitem' : isWord ? 'witem' : 'pitem', { active: isWord && !wordNoDir && item.selected }]"
      v-for="item in dataList"
      :key="item.id"
    >
      <div v-if="isWord && !wordNoDir" @click="onItemClick(item)" class="name">
        {{ item.name }}({{ item.links.length }})
      </div>
      <div class="links" v-if="item.selected">
        <div class="imgs" v-if="item.links.length > 0">
          <div class="img-con" :key="link.id" v-for="(link, sindex) in item.links">
            <el-image
              :ref="'el-image-' + sindex"
              :src="link.imageUrl"
              :preview-src-list="item.links.map(item => item.imageUrl)"
            ></el-image>
            <div class="option-con">
              <div @click="delItem(item, sindex)" class="btn">
                <i class="el-icon-delete"></i>
              </div>
              <div @click="moveUp(item, sindex)" class="btn">
                <i class="el-icon-arrow-up"></i>
              </div>
              <div @click="moveDown(item, sindex)" class="btn">
                <i class="el-icon-arrow-down"></i>
              </div>
            </div>
          </div>
        </div>
        <div class="no-pic" v-else>
          <template v-if="isWord && !wordNoDir">暂无素材</template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MoveList",
  props: {
    list: {
      type: Array,
      default: () => [],
    },
    fileType: {
      type: Number,
    },
  },
  watch: {
    list: {
      handler: function (val) {
        console.log(val, "检测值变化");
        this.dataList = val;
      },
      immediate: true,
      deep: true,
    },
  },
  computed: {
    isWord() {
      return this.fileType == 1;
    },
    wordNoDir() {
      return this.dataList.length == 1 && this.dataList[0].id === null && this.dataList[0].name == "" || this.dataList[0].name == null;
    },
  },
  data() {
    return {
      dataList: this.list,
    };
  },
  methods: {
    onItemClick(item) {
      if (item.selected) {
        item.selected = false;
        return;
      }
      this.dataList.forEach(item => {
        if (item.selected) {
          item.selected = false;
        }
      });
      item.selected = true;
    },
    hasLinks(item) {
      let allLinks = [];
      if (item.links) {
        item.links.forEach(link => {
          allLinks.push(link);
        });
      } else {
        let getIds = list => {
          for (let i = 0; i < list.length; i++) {
            const obj = list[i];
            if (obj.children && obj.children.length > 0) {
              getIds(obj.children);
            } else {
              if (obj.links) {
                obj.links.forEach(link => {
                  allLinks.push(link);
                });
              }
            }
          }
        };
        getIds(item.children);
      }

      return allLinks.length > 0;
    },
    delItem(item, index) {
      item.links.splice(index, 1);
      this.updateList();
    },
    updateList() {
      this.$emit("updateList");
    },
    moveUp(item, index) {
      console.log(index, item, "moveUp");
      if (index != 0) {
        let preItem = item.links[index - 1];
        if (!preItem.isRequired) {
          item.links[index] = item.links.splice(index - 1, 1, item.links[index])[0];
        }
      }
    },
    moveDown(item, index) {
      console.log(index, item, "moveDown");
      if (index != item.links.length - 1) {
        item.links[index] = item.links.splice(index + 1, 1, item.links[index])[0];
      }
    },
    mouseEntrImage(item) {
      if (this.fileType === 1) {
        item.showMark = true;
      }
    },
    mouseLeaveImage(item) {
      if (this.fileType === 1) {
        item.showMark = false;
      }
    },
    goPreview(url) {
      window.open(url);
    },
  },
};
</script>

<style lang="less" scoped>
.dir-list {
  & > .witem {
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-bottom: 10px;
    &:hover {
      border-color: #f599a9;
    }
    &.active {
      border-color: #e60027;
    }
    & > .name {
      padding: 10px 5px;
      cursor: pointer;
    }
    & > .links {
      & > .imgs {
        margin: 10px;
        & > .img-con {
          margin-bottom: 10px;
          position: relative;
          & > .option-con {
            opacity: 0;
            position: absolute;
            z-index: 999;
            right: 10px;
            top: 20px;
            & > .btn {
              width: 24px;
              height: 24px;
              border-radius: 12px;
              background: rgba(0, 0, 0, 0.45);
              color: #fff;
              text-align: center;
              line-height: 24px;
              margin-bottom: 2px;
              cursor: pointer;
            }
          }
          &:hover {
            & > .option-con {
              opacity: 1;
            }
          }
        }
      }
      & > .no-pic {
        padding: 100px 0;
        text-align: center;
        color: #666;
        font-size: 13px;
      }
    }
  }
  & > .nwitem {
    border-radius: 5px;
    margin-bottom: 10px;

    & > .name {
      padding: 10px 5px;
      cursor: pointer;
    }
    & > .links {
      & > .imgs {
        margin: 10px;
        & > .img-con {
          margin-bottom: 10px;
          position: relative;
          & > .option-con {
            opacity: 0;
            position: absolute;
            z-index: 999;
            right: 10px;
            top: 20px;
            & > .btn {
              width: 24px;
              height: 24px;
              border-radius: 12px;
              background: rgba(0, 0, 0, 0.45);
              color: #fff;
              text-align: center;
              line-height: 24px;
              margin-bottom: 2px;
              cursor: pointer;
            }
          }
          &:hover {
            & > .option-con {
              opacity: 1;
            }
          }
        }
      }
      & > .no-pic {
        padding: 100px 0;
        text-align: center;
        color: #666;
        font-size: 13px;
      }
    }
  }
  & > .pitem {
    margin-bottom: 10px;
    & > .name {
      padding: 10px 5px;
      cursor: pointer;
    }
    & > .links {
      & > .imgs {
        margin: 10px;
        & > .img-con {
          margin-bottom: 10px;
          position: relative;
          & > .option-con {
            opacity: 0;
            position: absolute;
            z-index: 999;
            right: 10px;
            top: 20px;
            & > .btn {
              width: 24px;
              height: 24px;
              border-radius: 12px;
              background: rgba(0, 0, 0, 0.45);
              color: #fff;
              text-align: center;
              line-height: 24px;
              margin-bottom: 2px;
              cursor: pointer;
            }
          }
          &:hover {
            & > .option-con {
              opacity: 1;
            }
          }
        }
      }
      & > .no-pic {
        padding: 100px 0;
        text-align: center;
        color: #666;
        font-size: 13px;
      }
    }
  }
}
</style>
